import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 20,
  },
});

const Loading: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <CircularProgress />
    </div>
  );
};

export default Loading;
